import { render, staticRenderFns } from "./promotionCell.vue?vue&type=template&id=35b12c16&scoped=true"
import script from "./promotionCell.vue?vue&type=script&lang=js"
export * from "./promotionCell.vue?vue&type=script&lang=js"
import style0 from "./promotionCell.vue?vue&type=style&index=0&id=35b12c16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b12c16",
  null
  
)

export default component.exports